export default __webpack_public_path__ + "assets/99e4d53bcf244be25bdd0efbc2ba1d3a.jpg";